export default "__VITE_ASSET__507d1e98__"